import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const CategoriesBarWrapperStyles = css`
  background: ${colors.purple};
`
export const CategoriesStyles = css``
export const CategoryLinkStyles = css`
  color: ${colors.white};
  &.active,
  &:hover {
    position: relative;
    overflow: hidden;
    color: ${colors.yellow};
    :before {
      display: block;
      content: "";
      position: absolute;
      bottom: -30%;
      width: 100%;
      height: 50%;
      background: radial-gradient(
        ellipse at center bottom,
        ${colors.yellow},
        transparent 70%
      );
    }
  }
`
